// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"98":"170d35fa","189":"05a373c1","202":"cbb0db52","217":"8dffb332","223":"3e97457e","422":"d4553934","633":"9a133967","983":"c0daa952"}[chunkId] + ".chunk.js";
};